import { useEffect, useState } from "react";

/**
 *Calculate the maximum height of the children of an element and adds an offset to it
 * @param {String} parentId the id of the parent element (footerCardsContainer)
 * @param {Integer} offset the offset to add to the max height (the header height)
 * and the footer top margin
 * @returns
 */
const useMaxHeightOfChildren = (
    parentId, // {String} - The id of the parent element (footerCardsContainer)
    offset, // {Integer} - The offset to add to the max height (the header's height, the margins and padding of the footer)
    footerRef // {Object} - The reference to the footer element to determin if the element is mounted
) => {
    const [maxHeight, setMaxHeight] = useState(0);

    useEffect(() => {
        const parentElement = document.getElementById(parentId);

        const updateMaxHeight = () => {
            if (!parentElement) {
                return;
            }

            const children = parentElement.children;

            const max = Array.from(children).reduce((max, el) => {
                const height = el.getBoundingClientRect().height;
                return height > max ? height : max;
            }, 0);

            setMaxHeight(max);
        };

        updateMaxHeight();

        // Create a MutationObserver to observe changes in the DOM
        const observer = new MutationObserver(updateMaxHeight);

        if (parentElement) {
            observer.observe(parentElement, {
                childList: true,
                subtree: true,
                attributes: true,
                characterData: true,
            });
        }
    }, [parentId, footerRef?.current]);

    return maxHeight + offset;
};

export default useMaxHeightOfChildren;
